module.exports = __webpack_public_path__ + "media/images/office_1-fd8dbda4560a504b161944fd6950cfd6.jpg";